export default __webpack_public_path__ + "static/19_35-8d56c8acc1ebeae83d6c75789e62975c.png";